// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>5</span>&nbsp;&nbsp;The Lord watches over the simple;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;I was brought very low and he saved me.<br> </p> </div></div>";
// Exports
module.exports = code;